/** @param {import("../viewer-deps.js").ViewerDeps} deps */
export function createSource(deps) {
  async function loadSample() {
    if (window.location.protocol === "file:") {
      throw new Error(
        "Viewer не работает по file://. Запустите: bun src-bff/serve.ts и откройте http://127.0.0.1:8765/",
      );
    }
    const generation = deps.bumpLoadSampleGeneration();
    const exampleFile = deps.activeExampleFileName();
    const fromExample = exampleFile != null;
    if (!fromExample) {
      deps.errorBox.hidden = false;
      deps.errorBox.textContent = "Загрузка контракта из AdminApp…";
    } else {
      deps.errorBox.hidden = false;
      deps.errorBox.textContent = `Загрузка example/${exampleFile}…`;
    }
    const contractApi = deps.contractApiUrl();
    const apiResponse = await fetch(contractApi, { cache: "no-store" });
    if (generation !== deps.getLoadSampleGeneration()) {
      return;
    }
    if (!apiResponse.ok) {
      const detail = await apiResponse.text();
      const sourceLabel = fromExample ? "example/" : "AdminApp";
      let message = `Контракт ${sourceLabel} (${apiResponse.status}): ${detail.slice(0, 400)}`;
      if (fromExample && apiResponse.status === 403) {
        message += " Запустите serve с BFF_LOCAL_EXAMPLES=1 (см. src-bff/serve.ts).";
      } else if (!fromExample) {
        message += " Запустите Slon.AdminApp.WebHost (http://localhost:5010), включите example/ (кнопка example/) или откройте ?workspace=file:example.json&localExamples=1";
      }
      throw new Error(message);
    }
    const envelope = await apiResponse.json();
    const contract =
      envelope.contract
      ?? envelope.sduiDraft
      ?? envelope.payload
      ?? envelope.Payload
      ?? envelope;
    if (!contract?.chrome || !contract?.tokens) {
      throw new Error("Ответ не содержит SDUI-документ (chrome и tokens).");
    }
    if (generation !== deps.getLoadSampleGeneration()) {
      return;
    }
    deps.ingestDocument(contract);
    deps.setDocFileName(fromExample ? (envelope.file ?? exampleFile) : "admin-contract.json");
    deps.setDocSource(fromExample ? "example" : "api");
    deps.setDocFileHandle(null);
    deps.finishDocumentLoad();
  }

  return { loadSample };
}
